import { useState } from 'react'
import './Auth.scss'
import image from '../../assets/images/4.jpeg'
import FormLoader from '../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import { postNo } from '../../utils/Api'
function Login() {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  function handleSubmit(data: any) {
    setLoading(true)
    postNo('admin/login', data)
      .then((res) => {
        if (res.status === 200) {
          const auth = {
            name: res?.data?.admin?.name,
            role: res?.data?.admin?.role,
            id: res?.data?.admin?._id,
            email: res?.data?.admin?.email,
          }
          sessionStorage.setItem('user', JSON.stringify(auth))
          sessionStorage.setItem('token', res?.data?.access_token)
          sessionStorage.setItem('refreshToken', res?.data?.refresh_tokens)
          setLoading(false)
          notify('success', res.message)
          navigate('/admin/home')
        } else {
          notify('error', res.message)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='auth flex'>
      <div className='left'>
        <img src={image} alt='delivery man image' />
      </div>
      <div className='right flex items-center'>
        <div className='wrap'>
          <div className='top'>
            <h1>Admin Login</h1>
          </div>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              const account = e.target.account.value
              const password = e.target.password.value
              if (!account || !password) {
                notify('warn', 'Please fill in all fields')
                return
              }
              // Handle form submission
              handleSubmit({ account: account.toLowerCase(), password })
            }}
          >
            <div className='card'>
              <p>Email</p>
              <input type='email' name='account' />
            </div>
            <div className='card'>
              <p>Password</p>
              <input type='password' name='password' />
            </div>
            <div className='card btn'>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <button type='submit'>Sign In</button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
